import React from "react";
import { Button, Input } from "../../atoms";
import { toDateInputValue } from "../../../utils/date";

export interface DateInputWithShortcutProps
  extends Omit<React.ComponentProps<typeof Input>, "type"> {
  shortcutDate?: Date | string | null;
  shortcutLabel?: string;
  onUseShortcut?: (value: string) => void;
}

export const DateInputWithShortcut: React.FC<DateInputWithShortcutProps> = ({
  shortcutDate,
  shortcutLabel = "Use start date",
  onUseShortcut,
  className = "",
  ...inputProps
}) => {
  const shortcutValue = shortcutDate ? toDateInputValue(shortcutDate) : "";
  const showShortcut = Boolean(shortcutValue && onUseShortcut);

  return (
    <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center">
      <Input
        type="date"
        className={`min-w-0 flex-1 ${className}`}
        {...inputProps}
      />
      {showShortcut && (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="shrink-0 whitespace-nowrap"
          onClick={() => onUseShortcut?.(shortcutValue)}
        >
          {shortcutLabel}
        </Button>
      )}
    </div>
  );
};
